
import Button from '@/components/elements/Button.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import ExamMasterList from '@/components/block/ExamMasterList.vue'
import { reactive, defineComponent } from 'vue'

export default defineComponent({
  name: 'MasterFooter',
  props: {
    ignoreId: Number
  },
  components: {
    HeadingLv3,
    ExamMasterList,
    Button
  },

  setup() {
    const state = reactive({
      category: '1'
    })
    const setCategory = (e: string) => {
      state.category = e
    }
    return {
      state,
      setCategory
    }
  }
})
